import service from "../../images/hospital.png"
import React from 'react'

const ServiceFurniture = () => {
    return (
        <>
            <div className='container'>
                <h6 className='service-head '> ALL SERVICES</h6>
                <div className='row'>
                    <div className='col-lg-5'>
                        <img src={service} height={300} className='w-100 br-20' alt={service} />
                        <h3 className='color-primary  text-center mt-2'>Hospitality Design</h3>
                    </div>
                    <div className='col-lg-7 mt-5 mb-5'>
                        <h3>Elevating Hospitality Through Inspired Design</h3>
                        <p>At AFS DOTE, we create exceptional spaces that redefine the guest experience. Specializing in hospitality design, we blend functionality with aesthetic excellence to craft environments that captivate and comfort. From boutique hotels to luxury resorts, our innovative approach ensures every project reflects the unique identity of your brand while delivering an unforgettable experience for your guests.</p>
                        <p>Our expertise includes:</p>
                        <ul>
                            <li>Hotel & Resort Design – Memorable spaces that evoke luxury and relaxation.</li>
                            <li>Restaurant & Bar Design – Dynamic interiors that enhance dining experiences.</li>
                            <li>Lounge & Lobby Design – Welcoming, stylish, and functional public areas.</li>
                            <li>Spa & Wellness Centers – Tranquil retreats promoting serenity and well-being.</li>
                            <p>With a focus on thoughtful design, sustainability, and guest-centric solutions, we transform visions into realities. Let us help you create a space that leaves a lasting impression.</p>
                            </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceFurniture
